import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { Player } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_URL as string;

export async function getPlayer(playerId: number): Promise<Player> {
  const { data } = await axios.get<Player>(`${API_BASE_URL}/api/players/${playerId}`);
  return data;
}

export function usePlayerInfo(playerId?: number | null) {
  const playerQuery = useQuery({
    queryKey: ["player", playerId] as const,
    queryFn: () => {
      if (playerId == null) throw new Error("playerId is required");
      return getPlayer(playerId);
    },
    enabled: playerId != null,
    staleTime: Infinity,          // ok in v5
    gcTime: 5 * 60 * 1000,        // v5 rename of cacheTime
    placeholderData: (prev) => prev, // v5 replacement for keepPreviousData
  });

  if (playerQuery.isError) {
    console.error("Error fetching player data for captainId:", playerId, playerQuery.error);
  }

  return {
    playerData: playerQuery.data ?? null,
    isLoading: playerQuery.isLoading,
    isError: playerQuery.isError,
  };
}
